<div class="diet-container">
  <div class="diet-chart">
    <canvas
      baseChart
      [datasets]="barChartData"
      [labels]="barChartLabels"
      [options]="barChartOptions"
      [chartType]="barChartType"
      [plugins]="barChartPlugins"
    >
    </canvas>
  </div>
  <div class="fake"></div>
</div>
